import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { handleBack } from "../../../utils/backButton";

const Error403 = () => {
  const navigate = useNavigate();
  const { role } = useSelector((state) => ({
    role: state.auth.role,
  }));

  return (
    <div className="fix-wrapper">
      <div className="container">
        {" "}
        <div className="row justify-content-center">
          <div className="col-md-5">
            <div className="form-input-content text-center error-page">
              <h1 className="error-text fw-bold">403</h1>
              <h4>
                <i className="fa fa-times-circle text-danger" /> Forbidden
                Error!
              </h4>
              <p>You do not have permission to view this resource.</p>
              <div>
                <button
                  onClick={() => handleBack(role, navigate)}
                  className="btn btn-primary"
                >
                  Back to Home
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Error403;
